import React from "react";
import { withNamespaces } from "react-i18next";
import { FaCompass, FaMap, FaPencil } from "react-icons/lib/fa";
import {
  Card,
  CardTitle,
  CardText,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  Button
} from "reactstrap";

const WelcomeIntro = props => {
  const { t } = props;

  return (
      <React.Fragment>
    <ModalBody>
    <Row>
      <Col sm="6">
        <Card body>
          <CardTitle>
            <FaCompass className="icon" size="1.3em" />{" "}
            <b>{t("welcome-explore-title")}</b>
          </CardTitle>
          <CardText>
            {t("welcome-explore-desc")}
            <br />
            <br />
            {t("welcome-explore-desc-extended")}
          </CardText>
        </Card>
      </Col>
      <Col sm="6">
        <Card body>
          <CardTitle>
            <FaPencil className="icon" size="1.3em" />{" "}
            <b>{t("welcome-report-title")}</b>
          </CardTitle>
          <CardText>
            {t("welcome-report-desc")}
            <br />
            <br />
            {t("welcome-report-desc-extended")}
          </CardText>
        </Card>
      </Col>
    </Row>
    </ModalBody>
        <ModalFooter>
        <Button color="primary" onClick={props.next}>
          <FaMap className="icon" />
          &nbsp;&nbsp;{t("welcome-next")}
        </Button>
      </ModalFooter>
      </React.Fragment>
  );
};

export default withNamespaces()(WelcomeIntro);



// WEBPACK FOOTER //
// ./src/WelcomeIntro.jsx